import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "add_black",
  "use": "add_black-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"add_black\">\n<rect width=\"24\" height=\"24\" rx=\"12\" fill=\"#424242\" />\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17 12.357H7V11.6427H17V12.357Z\" fill=\"white\" />\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.3569 7L12.3569 17L11.6426 17L11.6426 7L12.3569 7Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol